import { gql } from '@apollo/client';

export const SAVE_PACKAGE = gql`
  mutation SavePackage(
    $packageId: String
    $packageName: String!
    $variablesIncluded: [EnhancementVariableInput!]!
  ) {
    savePackage(
      packageId: $packageId
      packageName: $packageName
      variablesIncluded: $variablesIncluded
    ) {
      id
      name
      fileId
      variablesIncluded {
        id
        key
      }
      purchasedAt
    }
  }
`;

export const DELETE_PACKAGE = gql`
  mutation DeletePackage($packageId: String!) {
    deletePackage(packageId: $packageId) {
      message
    }
  }
`;
